/** The `overview.actions`, `channel.actions` and `hotspot.row.actions` slots (UX-SPEC §17, BENCH-UX-SPEC §5). */
import type { ChannelId } from '../../engine/channels/types.ts';
import { navigate } from '../router.ts';
import { BENCH } from '../strings-bench.ts';
import { startRewrite } from './controller.ts';

export function OverviewActions({ showTranslation }: { showTranslation: boolean }) {
	return (
		<div class="bench-actions bench-desktop-only" data-testid="overview-bench-actions">
			<button
				type="button"
				class="btn btn-secondary"
				onClick={() => {
					navigate('#/bench');
					startRewrite({ kind: 'flagged' });
				}}
			>
				{BENCH.rewriteFlagged}
			</button>
			<button
				type="button"
				class="btn btn-secondary"
				data-testid="overview-rewrite-document"
				onClick={() => {
					navigate('#/bench');
					startRewrite({ kind: 'document' });
				}}
			>
				{BENCH.rewriteDocument}
			</button>
			{showTranslation ? (
				<button
					type="button"
					class="btn btn-secondary"
					data-testid="overview-reduce-translation"
					onClick={() => {
						navigate('#/bench');
						startRewrite({ kind: 'translation' });
					}}
				>
					{BENCH.repairTranslation}
				</button>
			) : null}
		</div>
	);
}

export function ChannelAction({ id }: { id: ChannelId }) {
	return (
		<button
			type="button"
			class="btn btn-secondary bench-desktop-only"
			onClick={() => {
				navigate('#/bench');
				startRewrite({ kind: 'channel', id });
			}}
		>
			{BENCH.rewriteChannel}
		</button>
	);
}

export function HotspotAction({
	channel,
	paraStart,
	paraEnd,
}: { channel: ChannelId; paraStart: number; paraEnd: number }) {
	return (
		<button
			type="button"
			class="btn btn-secondary btn-sm bench-desktop-only"
			onClick={(e) => {
				e.stopPropagation();
				navigate('#/bench');
				startRewrite({ kind: 'hotspot', channel, paraStart, paraEnd });
			}}
		>
			{BENCH.rewriteStretch}
		</button>
	);
}
